import Toast, { PluginOptions } from "vue-toastification";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      notification: Toast,
    },
  };
});
